module.exports = "<div class=\"assign-pick-location-popup-container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-12\" >\r\n            <lfwms-result-data-table\r\n                [searchService]=\"searchService\"\r\n                [showSelectOption]=\"false\">\r\n            </lfwms-result-data-table>\r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/assign-pick-location-popup/assign-pick-location-popup.component.html
// module id = ../../../../../src/app/shared/lookup/assign-pick-location-popup/assign-pick-location-popup.component.html
// module chunks = main